import {
  getData, postData,
} from './apiCall';
import Urls from '../utils/util';
import {
  AddNodePayload, CreateNetworkPayload, CreateSubscriptionPayload, UpdateEndpointNamePayload, UpdateSecurityPayload, CreateEndpointPaload, CreateStakingNetworkPayload, AddStakingNodePayload,
} from './payloadTypes';

export const getNetworkList = async (networkType: string, type: string) => {
  const res = await getData(Urls.getNetworkListUrl(networkType, type));
  return res;
};

export const getWorkspaceListData = async () => {
  const res = await getData(Urls.getWorkspaceList());
  return res;
};

export const getUserDetails = async () => {
  const res = await getData(Urls.getUserInfo());
  return res;
};

export const getCloudRegionData = async (id: string | number) => {
  const res = await getData(Urls.getCloudRegion(id));
  return res;
};

export const getCloudListData = async () => {
  const res = await getData(Urls.getCloudList());
  return res;
};

export const getCredIdData = async (id:string) => {
  const res = await getData(Urls.getCredId(id));
  return res;
};

export const getNetworkDetailData = async (networkId: string | number) => {
  const res = await getData(Urls.getNetworkDetail(networkId));
  return res;
};

// For Single Node Add
export const addNodeData = async (
  payload: AddNodePayload,
  networkId: string,
) => {
  const res = await postData(Urls.addNodeUrl(networkId), payload);
  return res;
};

export const addStakingNodeData = async (
  payload: AddStakingNodePayload,
  networkId: string,
) => {
  const res = await postData(Urls.addNodeUrl(networkId), payload);
  return res;
};

export const createNetwork = async (payload: CreateNetworkPayload) => {
  const res = await postData(Urls.getCreateNetworkUrl(), payload);
  return res;
};

export const createStakingNetwork = async (payload: CreateStakingNetworkPayload) => {
  const res = await postData(Urls.getCreateNetworkUrl(), payload);
  return res;
};

export const getAccessToken = async () => {
  const res = await postData(Urls.getAccessTokenUrl(), {});
  return res;
};

export const getCredIdsData = async (id:string) => {
  const res = await getData(Urls.getCredId(id));
  return res;
};

export const getAllNodesData = async (id: string | number) => {
  const res = await getData(Urls.getAllNodes(id));
  return res;
};

export const deleteTheNetwork = async (networkId: string | number) => {
  const res = await getData(Urls.deleteNetworkById(networkId));
  return res;
};

export const deleteTheNode = async (netId: string, nodeId: string) => {
  const res = await getData(Urls.deleteNodeUrl(netId, nodeId));
  return res;
};

export const getNodeDetailsData = async (networkId: string, id: string) => {
  const res = await getData(Urls.getNodeDetails(networkId, id));
  return res;
};

export const getSubsComQuotaData = async (subscriptionId: string) => {
  const res = await getData(Urls.getSubsComQuotaUrl(subscriptionId));
  return res;
};

export const getBlockHeightData = async (networkId: string, id: string) => {
  const res = await getData(Urls.getNodeInfoUrl(networkId, id));
  return res;
};

export const getPlansData = async () => {
  const res = await getData(Urls.getPaymentPlans());
  return res;
};

export const getPlansForSharedNodesData = async () => {
  const res = await getData(Urls.getPlansForSharedNodes());
  return res;
};

export const createSubscription = async (payload: CreateSubscriptionPayload, queryValue: string) => {
  const res = await postData(Urls.getSubscription(queryValue), payload);
  return res;
};

export const getAvailableCountData = async (filterArr: string[]) => {
  const res = await getData(Urls.getAvailableCount(filterArr));
  return res;
};

export const getInstanceTypesData = async (id:string) => {
  const res = await getData(Urls.getInstanceTypes(id));
  return res;
};

export const getEndpointDetailsData = async (endpointId: string) => {
  const res = await getData(Urls.getEndpointDetailsUrl(endpointId));
  return res;
};

export const deleteTheEndpoint = async (endpointId: string) => {
  const res = await getData(Urls.getEndpointDeleteUrl(endpointId));
  return res;
};

export const updateEndpointName = async (payload: UpdateEndpointNamePayload, type: string) => {
  const res = await postData(Urls.getUpdateEndpointNameOrSecurityUrl(type), payload);
  return res;
};

export const updateSecurity = async (payload: UpdateSecurityPayload, type: string) => {
  const res = await postData(Urls.getUpdateEndpointNameOrSecurityUrl(type), payload);
  return res;
};

export const createEndpoint = async (payload: CreateEndpointPaload) => {
  const res = await postData(Urls.getCreateEndpointUrl(), payload);
  return res;
};

export const getSummaryData = async (endpointId: string) => {
  const res = await getData(Urls.getEndpointMatricsUrl(endpointId));
  return res;
};

export const getMethodCallData = async (endpointId: string) => {
  const res = await getData(Urls.getEndpointMethodCallUrl(endpointId));
  return res;
};

export const getRecentReqData = async (endpointId: string) => {
  const res = await getData(Urls.getEndpointRecenetReqUrl(endpointId));
  return res;
};

/**
 * Get the Region list form the backend
 * @returns
 */
export const getRegionList = async (protocolId: string) => {
  const res = await getData(Urls.getRegionListUrl(protocolId, false));
  return res;
};